
<div class="container">
    <h2>Manage your account</h2>
    <h4>Change your account settings</h4>
    <hr />
    <div class="row">
        <div class="col-md-3">
            <ul class="nav nav-pills flex-column">
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['/account/profile']"
                    routerLinkActive="active" >Profile</a></li>
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['/account/changeemail']"
                    routerLinkActive="active">Email</a></li>
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['/account/changepassword']"
                    routerLinkActive="active" >Password</a></li>
            </ul>
        </div>
        <div class="col-md-9">
            <h4>Change Your Password</h4>
            <div class="row">
                <div class="col-md-6">
                    <form #form="ngForm" (ngSubmit)="onSubmit()">
                        <div asp-validation-summary="All" class="text-danger"></div>
                        <div class="form-group">
                            <label >Current Password</label>
                            <input name="currentpassword" type="password"
                            [(ngModel)]="postmodel.currentpassword" required 
				#currentpassword="ngModel" class="form-control" />
                        </div>
                        <div class="form-group">
                            <label >New Password</label>
                            <input name="newpassword" type="password"
                            [(ngModel)]="postmodel.newpassword" required 
				#newpassword="ngModel" class="form-control" />
                        </div>
                        <div class="form-group">
                            <label >Confirm New Password</label>
                            <input name="confirmnewpassword" type="password"
                            [(ngModel)]="postmodel.confirmnewpassword" required 
				#confirmnewpassword="ngModel" class="form-control" />
                        </div>
                        <br>
                        <button [disabled]="form.invalid" type="submit" class="btn btn-primary">Update password</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>